import type {
    GetOptionPropsResult,
    OptionForCreate,
    OptionProps,
    PropSize,
    RenderItemProps,
    SelectAllItem,
} from 'uikit';

import React from 'react';

import { MemoizedSearchableSelectDropdownItem } from './SearchableSelectDropdownItem';

interface ISearchableSelectDropdownItem {
    visibleItems: (
        | OptionForCreate
        | {
              items: Array<SelectAllItem | any>;
              key: string | number;
              group?: any;
              groupIndex: number;
              checkedCount?: number;
              totalCount?: number;
          }
    )[];
    size: PropSize;
    indent: 'normal' | 'increased';
    labelForCreate?: string;
    getOptionProps(props?: OptionProps<any>): GetOptionPropsResult;
    getGroupLabel?: (group: any) => string;
    renderItem: (props: RenderItemProps<any>) => JSX.Element | null;
    isLastPage: boolean;
    lastPageRef?: (node: Element | null) => void;
}

export const SearchableSelectDropdownItemsPage: React.FC<ISearchableSelectDropdownItem> = (props) => {
    const {
        visibleItems,
        size,
        indent,
        labelForCreate,
        getOptionProps,
        getGroupLabel,
        renderItem,
        isLastPage,
        lastPageRef,
    } = props;

    return (
        <>
            {visibleItems.map((group) => (
                <MemoizedSearchableSelectDropdownItem
                    key={(group as any).key}
                    group={group}
                    indent={indent}
                    size={size}
                    renderItem={renderItem}
                    getOptionProps={getOptionProps}
                    getGroupLabel={getGroupLabel}
                    labelForCreate={labelForCreate}
                />
            ))}
            <div ref={isLastPage ? lastPageRef : null} />
        </>
    );
};

SearchableSelectDropdownItemsPage.displayName = 'SearchableSelectDropdownItemsPage';

export const MemoizedSearchableSelectDropdownItemsPage = React.memo(SearchableSelectDropdownItemsPage);
